(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/page-wrapper/page-wrapper.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/page-wrapper/page-wrapper.js');
"use strict";


const {
  Grid
} = svs.ui.ReactGrid;
const PageWrapper = _ref => {
  let {
    children
  } = _ref;
  return React.createElement("div", {
    className: "padding-xs-v-2 padding-xs-h-1 line-height-150"
  }, React.createElement(Grid, null, children));
};
svs.ticket_partner.sharedComponents.pageWrapper.PageWrapper = PageWrapper;

 })(window);